/// <reference types="@angular/google-maps" />
import { Component, ElementRef, NgZone, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PageBase, T4TurboOrderService, T4ListItem, RentalObjectWithLockInfo, LocationGroupInfo, SmartLockInfo } from 't4core';
import { LocationInfo } from '../../../../../projects/t4core/src/public-api';
import { style } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { T4ObjectLink } from '../../../../t4common';




@Component({
  styleUrls: ['./home.css'],
  selector: 'home',
  templateUrl: './home.component.html',
})
export class HomeComponent extends PageBase implements OnInit {

  @ViewChild('gmap', { static: true }) gmapElement: any;
  @ViewChild('txtMapSearch', { static: false }) gmapSearchBox: ElementRef;

  public locationGroups: LocationGroupInfo[] = [];
  public selectedConcept: LocationGroupInfo;
  public filteredConcepts: LocationGroupInfo[] = [];
  public filteredGroups: LocationGroupInfo[] = [];

  public gpsTrailers: RentalObjectWithLockInfo[] = [];
  public filteredGpsTrailers: RentalObjectWithLockInfo[] = [];

  public rentalLocationGroup: number = 0;
  public conceptRentalLocationGroup: number = 0;
  public locationId: number = 0;
  public type: number = 0;
  public searchText: string = '';
  public searchTextLocation: string = '';
  public searchTextGroup: string = '';

  public onlyMissingTrailers = new FormControl(false);
  public txtMapSearch: FormControl = new FormControl();
  public filterSectionCollapsed: boolean = true;
  private infoWindow = new google.maps.InfoWindow();
  private map: google.maps.Map;
  private searchBox: google.maps.places.Autocomplete;
  private searchPin: google.maps.marker.AdvancedMarkerElement; //changed to advancedmarkerele instead of old one

  private filteredMarkers = [];
  private locationMarkers = [];
  private trailerPoints = [];

  private autocompleteInitialized = false;

  private locations: LocationInfo[] = [];
  public filteredLocations: LocationInfo[] = [];
  public selectedLocation: LocationInfo;
  public selectedLocationCordAddress: string;

  public isChecked: boolean = false;
  public isChanged: boolean = false;

  private originalById = new Map<number, LocationSnapshot>();

  public lowerLimit: Date;
  public higherLimit: Date;

  public locationLoading: boolean = false;

  public mapLoading: boolean = false;

  address: any;
  latLng: any;
  marker: google.maps.marker.AdvancedMarkerElement;
  showUpdateProspect: boolean;
  Show: boolean;

  constructor(el: ElementRef, private orderSvc: T4TurboOrderService, private vcr: ViewContainerRef, private ngZone: NgZone) {
    super(el, "CustomerService");

  }

  private trailerMarkers: TrailerMarker[] = [];
  private trailerMarkersById = new Map<number, TrailerMarker>();
  private highlightedTrailerMarker: TrailerMarker | null = null;
  private selectedTrailerLocationId: number | null = null;
  private activeInfoWindowCleanup: (() => void) | null = null;

  private circlesById = new Map<number, google.maps.Circle>();
  private markersById = new Map<number, ZoomMarker>();
  private addressHandleByMarker = new WeakMap<google.maps.marker.AdvancedMarkerElement, { setValue: (v: string) => void }>();

  public async ngOnInit() {
    this.loadMap();
  }


  public async loadMap(){
    this.mapLoading = true;
    window.addEventListener('beforeunload', this.beforeUnloadListener);

    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    this.type = 0;
    this.rentalLocationGroup = 0;

    this.loadRentalLocationGroups();
    await this.loadTrailersWithGps();
    await this.updateLocations();
    await this.initTrailerMarkers();

    this.updateMap();
    this.map.setZoom(5);

    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      this.refreshViewportMarkers();

      this.ngZone.runOutsideAngular(() => {
        let scheduled = false;
        this.map.addListener('idle', () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => {
            scheduled = false;
            this.refreshViewportMarkers();
          });
        });
      });
    });

    this.map.addListener('click', async (e) => {
      if (!this.selectedLocation || !this.isChecked) return;

      const marker = this.markersById.get(this.selectedLocation.Id);
      const circle = this.circlesById.get(this.selectedLocation.Id);
      if (!marker || !circle || !e.latLng) return;


      const lat = e.latLng.lat();
      const lng = e.latLng.lng();


      marker.position = { lat, lng };
      circle.setCenter({ lat, lng });


      this.selectedLocation.TrailerPointLatitude = lat;
      this.selectedLocation.TrailerPointLongitude = lng;

      const addr = await this.reverseGeocode(lat, lng);
      this.addressHandleByMarker.get(marker)?.setValue(addr ?? 'Unavailable');
      this.selectedLocationCordAddress = addr ?? 'Unavailable';

      this.isChanged = true;
      this.refreshViewportMarkers?.();
    });



    this.installViewportHandler();
    this.refreshViewportMarkers();
    this.mapLoading = false;
  }

  public onSearchFocus() {
    if (this.autocompleteInitialized) return;
    this.autocompleteInitialized = true;
    this.initPlacesAutocomplete();
  }

  private initPlacesAutocomplete() {
    if (!this.gmapSearchBox?.nativeElement) return;

    this.searchBox = new google.maps.places.Autocomplete(this.gmapSearchBox.nativeElement, {
      componentRestrictions: { country: ['NO', 'SE', 'DK', 'DE', 'IS'] },
      types: ['geocode'],
      fields: ['geometry']
    });

    this.searchBox.addListener("place_changed", () => {
      let place: google.maps.places.PlaceResult = this.searchBox.getPlace();
      if (this.searchPin) this.searchPin.map = null;
      if (place.geometry === undefined || place.geometry === null) {
        return;
      }

      this.searchPin = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: place.geometry.location,
        zIndex: 2000,
        title: 'advMarkerTest'
      });

      this.map.panTo(place.geometry.location);
      this.map.setZoom(10);
    });

    this.gmapSearchBox.nativeElement.addEventListener('input', () => {
      if (this.gmapSearchBox.nativeElement.value === '') {
        if (this.searchPin) {
          this.searchPin.map = null;
          this.searchPin = null;
        }
      }
    });
  }

  // Adds a location to the map
  public addLocation(location: LocationInfo, showPin) {


    if (this.markersById.has(location.Id)) {
      return;
    }

    if (showPin) {
      const img = document.createElement('img');
      img.src = `/Images/blue-map-pin.png`;
      img.style.width = '40px';
      img.style.height = '40px';

      const pinWrapper = document.createElement('div');
      pinWrapper.appendChild(img);

      var marker = new google.maps.marker.AdvancedMarkerElement({
        map: null,
        position: { lat: location.TrailerPointLatitude, lng: location.TrailerPointLongitude },
        zIndex: 0,
        title: location.Name,
        gmpClickable: true,
        gmpDraggable: false,
        content: pinWrapper
      }) as ZoomMarker;

      marker.minZoom = 12;
      marker.zIndex = 1000;
      marker._id = location.Id;
      marker._iconImg = img;
      marker._iconWrapper = pinWrapper;

      // Click Event
      marker.addListener('gmp-click', async () => {

        const canSwitch = await this.ensureDiscardingUnsaved(location.Id);
        if (!canSwitch) return;

        this.locationLoading = true;
        this.disposeInfoWindowContent();
        this.clearSelectedTrailerPulse();
        this.resetHighlightedTrailerMarker();
        this.clearStationHighlight(marker);

        // --- Build content ---
        const wrapper = document.createElement('div');

        // --- Header with custom Close button ---
        const header = document.createElement('div');
        header.style.position = 'absolute';
        header.style.right = '0';
        header.style.top = '0';

        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.textContent = 'ˣ';
        closeBtn.title = 'Close';
        closeBtn.style.cssText = 'border: medium;background: transparent;font-size: 25px;cursor: pointer;line-height: 1;padding: 0px;height: 25px;width: 25px;margin:5px; ';

        closeBtn.addEventListener('click', async (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          const ok = await this.ensureDiscardingUnsaved(location.Id);
          if (!ok) return;
          this.addressHandleByMarker.delete(marker);
          this.clearSelectedLocationState();
          this.infoWindow.close();
          this.refreshViewportMarkers();
        });

        header.append(closeBtn);

        const fullAddress = [
          location.Address,
          location.ZipCode,
          location.City
        ].filter(v => v && v.trim() !== '').join(', ');

        const nodes = [
          this.line('Name', location.Name),
          this.line('Address', fullAddress),
        ].filter(Boolean) as HTMLElement[];

        const divider = document.createElement('div');
        divider.style.margin = '8px 0';

        // Use the handle-based row (no placeholder + replace)
        const currentAddr = this.lineWithHandle('Current Address', 'Resolving…');

        wrapper.append(header, ...nodes, divider, currentAddr.row);

        this.infoWindow.setContent(wrapper);
        this.infoWindow.open({ map: this.map, anchor: marker });

        // store handle so drag events can update this row
        this.addressHandleByMarker.set(marker, currentAddr);


        this.selectLocation(location);


        // reverse geocode current position
        const pos = marker.position as google.maps.LatLng | google.maps.LatLngLiteral;
        this.locationLoading = false;
        if (pos) {
          const lat = pos instanceof google.maps.LatLng ? pos.lat() : pos.lat;
          const lng = pos instanceof google.maps.LatLng ? pos.lng() : pos.lng;
          const addr = await this.reverseGeocode(lat, lng);
          currentAddr.setValue(addr ?? 'Unavailable');

        }
        else {
          currentAddr.setValue('Unavailable')
        }


        google.maps.event.addListenerOnce(this.infoWindow, 'closeclick', async () => {
          const canSwitch = await this.ensureDiscardingUnsaved(0);
          if (!canSwitch) return;
          this.addressHandleByMarker.delete(marker);
          this.clearSelectedLocationState();
        });
      });

      // Drag Event
      marker.addListener('dragend', async (e) => {
        const latLng = e.latLng;

        location.TrailerPointLatitude = latLng.lat();
        location.TrailerPointLongitude = latLng.lng();

        const latlngAddress = await this.reverseGeocode(latLng.lat(), latLng.lng());

        const handle = this.addressHandleByMarker.get(marker);
        handle?.setValue(latlngAddress ?? 'Unavailable');
        this.selectedLocationCordAddress = latlngAddress;

        circle.setCenter(latLng);
        this.isChanged = true;
      });

      this.markersById.set(location.Id, marker)
      this.locationMarkers.push(marker);

      const circle = new google.maps.Circle({
        center: { lat: location.TrailerPointLatitude, lng: location.TrailerPointLongitude },
        radius: location.TrailerPointRadius ?? 100,
        strokeColor: "#32CD32",
        strokeOpacity: 0.75,
        strokeWeight: 3,
        fillColor: "#32CD32",
        fillOpacity: 0.35,
        clickable: false,
        zIndex: 0,
        map: null,
      });

      circle.setCenter({ lat: location.TrailerPointLatitude, lng: location.TrailerPointLongitude });
      this.circlesById.set(location.Id, circle);
      this.trailerPoints.push(circle);

    }
  }


  private async initMap() {
    var mapProp = {
      center: new google.maps.LatLng(60.5793, 14.8143),
      zoom: 5,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: '17c55b6aa3c322c5',
      clickableIcons: false,
    };

    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

  }


  private initTrailerMarkers() {
    if (!this.map) this.initMap();

    for (const trailer of this.gpsTrailers) {
      const gps = trailer.GpsLock;
      if (gps?.Latitude == null || gps?.Longitude == null) continue;

      const img = document.createElement('img');
      img.src = `/Images/${this.getTrailerMarkerColor(trailer)}.png`;
      img.style.width = '40px';
      img.style.height = '40px';

      const marker = new google.maps.marker.AdvancedMarkerElement({
        map: null,
        position: new google.maps.LatLng(gps.Latitude, gps.Longitude),
        title: `Trailer: ${trailer.Name}\nDate: ${this.formatTrailerLastUpdate(trailer)}`,
        content: img,
        gmpClickable: true
      }) as TrailerMarker;

      marker._trailerId = trailer.Id;
      marker._locationId = trailer.LocationId;
      marker._iconImg = img;
      marker._openPopup = async () => this.openTrailerPopup(trailer, marker);

      marker.addEventListener('gmp-click', async () => {
        await marker._openPopup?.();
      });

      this.trailerMarkers.push(marker);
      this.trailerMarkersById.set(trailer.Id, marker);
    }
  }

  public async locateTrailer(trailer: RentalObjectWithLockInfo) {
    
    const trailerId = Number(trailer?.Id);
    if (!Number.isFinite(trailerId)) return;
   
    let marker = this.trailerMarkersById.get(trailerId);
    if (!marker) {
      marker = this.trailerMarkers.find(x => Number(x._trailerId) === trailerId);
      if (marker) {
        this.trailerMarkersById.set(trailerId, marker);
      }
    }

    if (!marker) return;
    
    const pos = marker.position;
    
    if (!pos) return;
    
    const latLng = pos instanceof google.maps.LatLng
      ? pos
      : new google.maps.LatLng((pos as google.maps.LatLngLiteral).lat, (pos as google.maps.LatLngLiteral).lng);

    this.map.panTo(latLng);
    this.map.setZoom(15);
    
    google.maps.event.addListenerOnce(this.map, 'idle', async () => {
      await marker._openPopup?.();
    });
    
  }

  private async openTrailerPopup(trailer: RentalObjectWithLockInfo, marker: TrailerMarker): Promise<boolean> {
    if (this.selectedLocation) {
      const canSwitch = await this.ensureDiscardingUnsaved(0);
      if (!canSwitch) return false;
      this.clearSelectedLocationState();
    }

    this.disposeInfoWindowContent();
    this.infoWindow.close();
    this.clearSelectedTrailerState();
    this.resetHighlightedTrailerMarker();
    this.selectedTrailerLocationId = trailer.LocationId ?? null;
    this.highlightTrailerMarker(marker);
    this.refreshViewportMarkers();

    if (this.selectedTrailerLocationId != null) {
      const stationMarker = this.getStationMarkerById(this.selectedTrailerLocationId);
      if (stationMarker) this.highlightStationMarker(stationMarker);
    }

    const compRef = this.vcr.createComponent(T4ObjectLink);
    compRef.instance.objectId = trailer.Id;
    compRef.instance.displayText = trailer.Concept == "OneWay" ? `${trailer.Alias} - (${trailer.Name})` : `${trailer.Name}`;
    compRef.changeDetectorRef.detectChanges();

    const hostEl = compRef.location.nativeElement as HTMLElement;

    const wrapper = document.createElement('div');
    const row = document.createElement('div');
    row.style.display = 'flex';
    row.style.alignItems = 'center';
    row.style.gap = '4px';
    const label = document.createElement('span');
    label.textContent = 'Trailer:';
    label.style.fontWeight = '600';
    row.append(label, hostEl);

    const header = document.createElement('div');
    header.style.position = 'absolute';
    header.style.right = '0';
    header.style.top = '0';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = 'ˣ';
    closeBtn.title = 'Close';
    closeBtn.style.cssText = 'border: medium;background: transparent;font-size: 25px;cursor: pointer;line-height: 1;padding: 0px;height: 25px;width: 25px;margin:5px; ';

    closeBtn.addEventListener('click', async (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.disposeInfoWindowContent();
      this.infoWindow.close();
      this.clearSelectedTrailerState();
      this.resetHighlightedTrailerMarker();
    });

    header.append(closeBtn);

    const nodes = [
      row,
      this.line('Concept', trailer.Concept),
      this.line('Location', trailer.LocationName),
      this.line('Date', this.formatTrailerLastUpdate(trailer))
    ].filter(Boolean) as HTMLElement[];

    wrapper.append(header, ...nodes);

    if (this.isTrailerMissing(trailer)) {
      const footer = document.createElement('div');
      footer.style.display = 'flex';
      footer.style.justifyContent = 'center';
      footer.style.marginTop = '8px';
      footer.style.marginLeft = '35px';
      footer.style.marginBottom = '2px';

      const atStationBtn = document.createElement('button');
      atStationBtn.type = 'button';
      atStationBtn.textContent = 'At Station';
      atStationBtn.title = 'Mark as at station';
      atStationBtn.classList.add(
        'mat-mdc-raised-button',
        'mat-mdc-button-base',
        'mat-primary',
        'mdc-button',
        'mdc-button--raised'
      );

      atStationBtn.style.cssText = 'max-height:25px';

      atStationBtn.addEventListener('click', async (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const gpsLock = trailer.GpsLock;
        if (!gpsLock) return;

        const result = await this.MarkGpsAtLocation(gpsLock);
        if (!result || !marker._iconImg) return;

        gpsLock.AtStation = true;
        marker._iconImg.src = `/Images/${this.getTrailerMarkerColor(trailer)}.png`;
        footer.remove();
        await this.updateFilter();
      });

      footer.append(atStationBtn);
      wrapper.append(footer);
    }

    this.activeInfoWindowCleanup = () => {
      compRef.destroy();
      this.activeInfoWindowCleanup = null;
    };

    this.infoWindow.setContent(wrapper);
    this.infoWindow.open({ map: this.map, anchor: marker });

    const pos = marker.position;
    if (pos) {
      const latLng = pos instanceof google.maps.LatLng
        ? pos
        : new google.maps.LatLng((pos as google.maps.LatLngLiteral).lat, (pos as google.maps.LatLngLiteral).lng);
      this.map.panTo(latLng);
    }

    google.maps.event.addListenerOnce(this.infoWindow, 'closeclick', () => {
      this.disposeInfoWindowContent();
      this.clearSelectedTrailerState();
      this.resetHighlightedTrailerMarker();
    });

    return true;
  }

  private getTrailerMarkerColor(trailer: RentalObjectWithLockInfo): string {
    const gps = trailer.GpsLock;
    if (!gps) return 'green-map-pin';

    const isStale = !this.isTrailerMissing(trailer) && gps.LastUpdate?.isBefore(moment().subtract(14, 'days'));
    return this.isTrailerMissing(trailer) ? 'red-map-pin' : isStale ? 'yellow-map-pin' : 'green-map-pin';
  }

  private highlightTrailerMarker(marker: TrailerMarker) {
    this.resetHighlightedTrailerMarker();

    if (!marker._iconImg) return;

    marker._iconImg.style.transform = 'scale(1.15)';
    marker._iconImg.style.filter = 'drop-shadow(0 0 8px rgba(25, 118, 210, 0.9))';
    marker.zIndex = 2500;
    this.highlightedTrailerMarker = marker;
  }

  private highlightStationMarker(marker: ZoomMarker) {
    const wrapper = marker._iconWrapper;
    if (!wrapper) return;

    wrapper.classList.remove('station-pulse-pin');
    void wrapper.offsetWidth;
    wrapper.classList.add('station-pulse-pin');
    marker.zIndex = 2501;
  }

  private disposeInfoWindowContent() {
    this.activeInfoWindowCleanup?.();
    this.activeInfoWindowCleanup = null;
  }

  private async loadRentalLocationGroups() {
    this.locationGroups = await this.Api.get<LocationGroupInfo[]>("TurboOrder/GetAllConceptGroups", { includeChildren: true });
    this.filteredConcepts = this.locationGroups;

  }
  //Search Function.
  public filterConcept() {
    this.filteredConcepts = this.locationGroups.filter(group => group.Name.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  public filterGroups() {
    this.filteredGroups = this.filteredConcepts.flatMap(c => c.ChildGroups ?? []).filter(group => group.Name.toLowerCase().includes(this.searchTextGroup.toLowerCase()));
  }

  public filterLocation() {
    this.filteredLocations = this.filteredLocations.filter(location => location.Name.toLowerCase().includes(this.searchTextLocation.toLowerCase()));
  }

  public resetSearch(opened: boolean, type: string) {
    if (!opened) {

      if (type == "concept") {
        this.searchText = '';
        this.filteredConcepts = this.locationGroups;
      }
      else if (type == "group") {
        this.searchTextGroup = '';
      }
      else if (type == "location") {
        this.searchTextLocation = '';
        
      }   
    }
  }

  private async loadTrailersWithGps() {
    this.gpsTrailers = await this.Api.get<RentalObjectWithLockInfo[]>("RentalObject/GetGpsTrailers", {});
    await this.updateFilter();
  }


  private async MarkGpsAtLocation(lock: SmartLockInfo) {
      var res = await this.Api.post<any>("RentalObject/ManuallyMarkGpsAtLocation", null, {tracker: lock.Id} )
      if(res){
        this.UI.snackBarLocal('T4.CustomerService.Map.MarkedAtLocation', 'Marked that its at Location')
        return true;
      }
      else{
        this.UI.snackBarLocal('T4.CustomerService.Map.MarkedAtLocationFailed', 'Error, unable to mark it at station.')
        return false;
      }
  }

  public get missingTrailers(): RentalObjectWithLockInfo[] {
    return [...this.filteredGpsTrailers]
      .filter(trailer => this.isTrailerMissing(trailer) && this.hasTrailerPin(trailer))
      .sort((a, b) => this.getTrailerLastUpdateMs(a) - this.getTrailerLastUpdateMs(b));
  }

  public formatTrailerLastUpdate(trailer: RentalObjectWithLockInfo): string {
    const lastUpdate = trailer.GpsLock?.LastUpdate;
    return lastUpdate ? lastUpdate.toDate().toLocaleString() : 'Unknown';
  }

  public getMissingDurationText(trailer: RentalObjectWithLockInfo): string {
    const lastUpdate = trailer.GpsLock?.LastUpdate;
    if (!lastUpdate) return 'Unknown';

    return this.formatDuration(moment.duration(moment().diff(lastUpdate)));
  }

  private isTrailerMissing(trailer: RentalObjectWithLockInfo): boolean {
    return !trailer.GpsLock?.AtStation && !trailer.GpsLock?.OnActiveBooking;
  }

  private hasTrailerPin(trailer: RentalObjectWithLockInfo): boolean {
    const gps = trailer.GpsLock;
    return gps?.Latitude != null && gps?.Longitude != null && this.trailerMarkersById.has(Number(trailer.Id));
  }

  private getTrailerLastUpdateMs(trailer: RentalObjectWithLockInfo): number {
    return trailer.GpsLock?.LastUpdate?.valueOf() ?? Number.MAX_SAFE_INTEGER;
  }

  private formatDuration(duration: moment.Duration): string {
    const totalMinutes = Math.max(0, Math.floor(duration.asMinutes()));
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    const parts: string[] = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0 || days > 0) parts.push(`${hours}h`);
    parts.push(`${minutes}m`);

    return parts.join(' ');
  }

  public async refreshData(){
    if(this.isChanged){
    var res = await this.UI.confirm("Turbo.CustomerService.Map.ConfirmRefreshData", "Unsaved changes", "Turbo.CustomerService.Map.msgConfirmRefreshData", "You have unsaved changes. Are you sure you want to leave?");

    if(res){
      this.isChanged = false;
     this.clearTrailerMarkers();
     await this.loadMap();
     }
    }
    else{
     this.clearTrailerMarkers();
     await this.loadMap();
    }
    
  }

  private clearTrailerMarkers() {
  // Remove markers from the map
  for (const marker of this.trailerMarkers) {

    marker.map = null;
  }

  this.clearSelectedTrailerState();

  // Clear collections
  this.trailerMarkers = [];
  this.trailerMarkersById.clear();

  this.clearSelectedLocationState();
  this.infoWindow?.close();
}

  public async updateFilter() {


    // <==== Filtering of Trailers ====>

    const missingOnly = this.onlyMissingTrailers.value;

    this.filteredGpsTrailers = this.gpsTrailers.filter(trailer => {
      // Concept / Group / Location filter
      if (!this.trailerMatchesConceptGroupLocation(trailer)) return false;

      // Time range filter
      const lastUpdate = trailer.GpsLock?.LastUpdate?.toDate?.();
      if (!lastUpdate) return false;

      const withinLower = !this.lowerLimit || lastUpdate >= this.lowerLimit;
      const withinUpper = !this.higherLimit || lastUpdate <= this.higherLimit;
      if (!withinLower || !withinUpper) return false;

      // Only missing
      if (missingOnly) {
        const notAtStation = !trailer.GpsLock?.AtStation;
        const notOnActiveBooking = !trailer.GpsLock?.OnActiveBooking;
        if (!notAtStation || !notOnActiveBooking) return false;
      }

      return true;
    });

    // <==== Concept/Group/Location ====>
    const conceptId = this.conceptRentalLocationGroup || 0;
    const groupId = this.rentalLocationGroup || 0;
    const locId = this.locationId || 0;

    this.selectedConcept = conceptId === 0 ? null : this.locationGroups.find(c => c.Id === conceptId) ?? null;

    if (conceptId === 3) { //Oneway
      this.filteredGroups = [];
      this.rentalLocationGroup = 0;
    } else if (this.selectedConcept) {
      this.filteredGroups = [...(this.selectedConcept.ChildGroups ?? [])];
    } else {
      const allChildGroups = this.locationGroups.flatMap(c => c.ChildGroups ?? []);


      //So we dont add duplicates.
      const seen = new Set<number>();
      this.filteredGroups = allChildGroups.filter(g => {
        if (seen.has(g.Id)) return false;
        seen.add(g.Id);
        return true;
      });
    }
 
    if (locId > 0) {
      // a single location overrides everything else
      this.filteredLocations = this.locations.filter(l => l.Id === locId);
    } else if (conceptId === 3) {
      // OneWay special: ignore group, only one-way locations
      this.filteredLocations = this.locations.filter(l => l.IsOneWay === true);
    } else {
      // Normal concept / group logic
      let allowedGroupIds: Set<number> | null = null;

      if (groupId > 0) {
        allowedGroupIds = new Set([groupId]);
      } else if (this.selectedConcept) {
        allowedGroupIds = new Set((this.selectedConcept.ChildGroups ?? []).map(g => g.Id));
      }

      const inAllowedGroups = (hierarchy?: string) => {
        if (!allowedGroupIds) return true;
        if (!hierarchy) return false;
        return hierarchy.split('-').some(part => allowedGroupIds!.has(Number(part)));
      };

      this.filteredLocations = this.locations.filter(l => inAllowedGroups(l.Hierarchy));
    }

    await this.updateMap();
  }

  private async updateMap() {
    if (!this.map) {
      this.initMap();
    }

    this.refreshTrailerMarkers();
    this.refreshViewportMarkers();

    this.addLocations();
  }
 

  public async onTypeChange(value: number) {
    this.type = value;
    if (this.type == 0) {
      if (this.gpsTrailers && this.gpsTrailers.length > 0) {
        await this.updateFilter();
      }
      else {
        await this.loadTrailersWithGps();
      }
    }
    else if (this.type == 1) {
      await this.updateMap();
    }
  }

  public async onConceptChange(value: number) {
    this.conceptRentalLocationGroup = value;
    this.rentalLocationGroup = 0;
    this.locationId = 0;
    await this.updateFilter();
  }

  public async onGroupChange(value: number) {
    this.rentalLocationGroup = value;
    this.locationId = 0;
    await this.updateFilter();
  }

  public async onLocationChange(value: number) {

    const marker = this.markersById.get(value);
    if (this.map.getZoom() < 12 && value != 0)
      this.map.setZoom(12);

    if (value != 0 && marker != null) {
      this.map.panTo(marker.position);
      this.selectLocation(this.locations.find(l => l.Id === value));
      google.maps.event.trigger(marker, 'gmp-click');
    }

    await this.updateFilter();
  }

  private async selectLocation(x: LocationInfo) {
    this.isChecked = false;
    this.selectedLocation = x;
    this.clearSelectedTrailerState();
    this.selectedLocationCordAddress = await this.reverseGeocode(x.TrailerPointLatitude, x.TrailerPointLongitude);
  }

  public async closeSelectedLocation() {
    if (!this.selectedLocation) return;

    const canClose = await this.ensureDiscardingUnsaved(0);
    if (!canClose) return;

    this.clearSelectedLocationState();
    this.infoWindow.close();
    this.refreshViewportMarkers();
  }

  private clearSelectedLocationState() {
    const currentId = this.selectedLocation?.Id;
    if (currentId != null) {
      const marker = this.getStationMarkerById(currentId);
      if (marker) marker.gmpDraggable = false;
    }

    this.selectedLocation = null;
    this.selectedLocationCordAddress = '';
    this.isChecked = false;
  }

  private clearSelectedTrailerPulse() {
    if (this.selectedTrailerLocationId != null) {
      const stationMarker = this.getStationMarkerById(this.selectedTrailerLocationId);
      if (stationMarker) this.clearStationHighlight(stationMarker);
    }
  }

  private clearSelectedTrailerState() {
    this.selectedTrailerLocationId = null;
    this.refreshViewportMarkers();
  }

  private resetHighlightedTrailerMarker() {
    if (!this.highlightedTrailerMarker?._iconImg) return;

    this.highlightedTrailerMarker._iconImg.style.transform = '';
    this.highlightedTrailerMarker._iconImg.style.filter = '';
    this.highlightedTrailerMarker.zIndex = undefined;
    this.highlightedTrailerMarker = null;
  }

  private clearStationHighlight(marker?: ZoomMarker | null) {
    if (!marker?._iconWrapper) return;

    marker._iconWrapper.classList.remove('station-pulse-pin');
    marker.zIndex = undefined;
  }

  private getStationMarkerById(id: number): ZoomMarker | undefined {
    return this.markersById.get(id) ?? this.locationMarkers.find(x => (x as ZoomMarker)._id === id) as ZoomMarker | undefined;
  }

  public onRadiusChange(value: number, locationId?: number) {
    if (!locationId) return;
    const circle = this.circlesById.get(locationId);
    if (!circle || !Number.isFinite(value)) return;

    this.isChanged = true;
    circle.setRadius(value);
    this.updateSnapshot(locationId, this.selectedLocation);
  }

  public onTogglePin(unlocked: boolean, id?: number) {
    if (!id) return;
    const loc = this.selectedLocation;
    if (!loc) return;

    if (unlocked) this.updateSnapshot(id, loc);

    const marker = this.getStationMarkerById(id);
    if (marker) marker.gmpDraggable = unlocked;

    this.isChecked = unlocked;
  }

  public clearLowerDate(event) {
    event.stopPropagation();
    this.lowerLimit = null;
  }

  public clearHigherDate(event) {
    event.stopPropagation();
    this.higherLimit = null;
  }

  public clearFilters() {
    this.lowerLimit = null;
    this.higherLimit = null;
    this.conceptRentalLocationGroup = 0;
    this.rentalLocationGroup = 0;
    this.locationId = 0;
    this.onlyMissingTrailers.setValue(false);
    this.searchText = '';
    this.searchTextGroup = '';
    this.searchTextLocation = '';
    this.resetSearch(false, 'concept');
    this.resetSearch(false, 'group');
    this.resetSearch(false, 'location');
    this.updateFilter();
  }

  public toggleFilterSection() {
    this.filterSectionCollapsed = !this.filterSectionCollapsed;
  }

  public get activeFilterCount(): number {
    let count = 0;
    if (this.lowerLimit) count++;
    if (this.higherLimit) count++;
    if ((this.conceptRentalLocationGroup || 0) > 0) count++;
    if ((this.rentalLocationGroup || 0) > 0) count++;
    if ((this.locationId || 0) > 0) count++;
    if (this.onlyMissingTrailers.value) count++;
    return count;
  }

  public updateMarkerVisibility = () => {
    const z = this.map.getZoom() ?? 0;

    const toShow: google.maps.marker.AdvancedMarkerElement[] = [];
    const toHide: google.maps.marker.AdvancedMarkerElement[] = [];

    for (const m of this.locationMarkers) {
      const min = (m as any).minZoom ?? 0;
      const max = (m as any).maxZoom ?? 30;

      const shouldShow = z >= min && z <= max;
      const isShown = !!m.map;

      if (shouldShow && !isShown) toShow.push(m);
      else if (!shouldShow && isShown) toHide.push(m);
    }

    // apply in batches to avoid blocking the main thread
    const BATCH = 50;
    let i = 0, j = 0;

    const step = () => {
      let n = 0;
      while (i < toShow.length && n < BATCH) { toShow[i++].map = this.map; n++; }
      while (j < toHide.length && n < BATCH) { toHide[j++].map = null; n++; }
      if (i < toShow.length || j < toHide.length) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };


  private async updateLocations() {
    this.locations = await this.Api.get<LocationInfo[]>("Location/GetLocations", {});
    this.filteredLocations = this.locations;
  }

  private addLocations() {
    this.filteredLocations.forEach(x => {
      this.addLocation(x, true);
    })
  }

  // Reverse Search / Reverse Geo Coder, getting current address on the selected marker.
  // Adding cache in case.
  private geocoder = new google.maps.Geocoder();
  private geocodeCache = new Map<string, string>();

  private async reverseGeocode(lat: number, lng: number): Promise<string | null> {
    const key = `${lat.toFixed(6)},${lng.toFixed(6)}`;
    if (this.geocodeCache.has(key)) return this.geocodeCache.get(key)!;

    try {
      const { results } = await this.geocoder.geocode({ location: { lat, lng } }); // no 'status' here
      if (!results?.length) return null;

      const best =
        results.find(r => r.types.includes('street_address') || r.types.includes('premise')) ??
        results[0];

      const addr = best.formatted_address;
      this.geocodeCache.set(key, addr);
      return addr;
    } catch (err) {
      console.log('Reverse geocode failed', err);
      return null;
    }
  }

  private refreshViewportMarkers = (paddingRatio = 0.10) => {
    const bounds = this.map.getBounds();
    if (!bounds) return;

    const sw = bounds.getSouthWest(), ne = bounds.getNorthEast();
    const latSpan = Math.abs(ne.lat() - sw.lat());
    const lngSpan = ((ne.lng() - sw.lng()) + 360) % 360;
    const padLat = latSpan * paddingRatio;
    const padLng = lngSpan * paddingRatio;

    const padded = new google.maps.LatLngBounds(
      new google.maps.LatLng(sw.lat() - padLat, sw.lng() - padLng),
      new google.maps.LatLng(ne.lat() + padLat, ne.lng() + padLng)
    );

    const z = this.map.getZoom() ?? 0;

    const selectedId = this.selectedLocation?.Id ?? null;

    const allowedLocationIds = new Set(this.filteredLocations.map(l => l.Id));

    const toShowMarkers: ZoomMarker[] = [];
    const toHideMarkers: ZoomMarker[] = [];
    const toShowCircles: google.maps.Circle[] = [];
    const toHideCircles: google.maps.Circle[] = [];


    for (const marker of this.locationMarkers as ZoomMarker[]) {
      const id = marker._id;
      const circle = this.circlesById.get(id) || null;

      const min = marker.minZoom ?? 0;
      const max = marker.maxZoom ?? 30;
      const zoomOK = z >= min && z <= max;

      const pos = marker.position as google.maps.LatLng | google.maps.LatLngLiteral;
      const ll = pos instanceof google.maps.LatLng ? pos : new google.maps.LatLng(pos.lat, pos.lng);
      const inView = padded.contains(ll);

      let shouldShow = zoomOK && inView && allowedLocationIds.has(id);

      // pin selected location regardless of zoom/bounds/filter
      if (selectedId !== null && id === selectedId) {
        shouldShow = true;
      }

      if (this.selectedTrailerLocationId !== null && id === this.selectedTrailerLocationId) {
        shouldShow = true;
        if (circle) toShowCircles.push(circle);
      }

      const isShown = !!marker.map;

      if (shouldShow && !isShown) {
        toShowMarkers.push(marker);
        if (circle) toShowCircles.push(circle);
      } else if (!shouldShow && isShown) {
        toHideMarkers.push(marker);
        if (circle) toHideCircles.push(circle);
      }
    }

    // Batch updates to avoid loading Issues / Perfomance issues.

    const BATCH = 50;
    let i = 0, j = 0, k = 0, l = 0;

    const step = () => {
      let n = 0;
      while (i < toShowMarkers.length && n < BATCH) { toShowMarkers[i++].map = this.map; n++; }
      while (j < toHideMarkers.length && n < BATCH) { toHideMarkers[j++].map = null; n++; }
      while (k < toShowCircles.length && n < BATCH) { toShowCircles[k++].setMap(this.map); n++; }
      while (l < toHideCircles.length && n < BATCH) { toHideCircles[l++].setMap(null); n++; }

      if (i < toShowMarkers.length || j < toHideMarkers.length || k < toShowCircles.length || l < toHideCircles.length) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };


  private refreshTrailerMarkers() {

    const allowedTrailerIds = new Set(this.filteredGpsTrailers.map(t => t.Id));
    const allowedLocationIds = new Set(this.filteredLocations.map(l => l.Id));

    const toShow: google.maps.marker.AdvancedMarkerElement[] = [];
    const toHide: google.maps.marker.AdvancedMarkerElement[] = [];

    for (const m of this.trailerMarkers as (google.maps.marker.AdvancedMarkerElement & { _trailerId?: number; _locationId?: number })[]) {
      const trailerId = m._trailerId!;
      const locId = m._locationId;

      let shouldShow = allowedTrailerIds.has(trailerId);

      if (shouldShow && locId != null && allowedLocationIds.size > 0) {
        shouldShow = allowedLocationIds.has(locId);
      }

      const isShown = !!m.map;

      if (shouldShow && !isShown) {
        toShow.push(m);
      } else if (!shouldShow && isShown) {
        toHide.push(m);
      }

      if (shouldShow && this.selectedTrailerLocationId !== null && locId === this.selectedTrailerLocationId) {
        this.clearStationHighlight(m as ZoomMarker);
      }
    }

    // batch show/hide to keep UI smooth
    const BATCH = 50;
    let i = 0, j = 0;

    const step = () => {
      let n = 0;
      while (i < toShow.length && n < BATCH) { toShow[i++].map = this.map; n++; }
      while (j < toHide.length && n < BATCH) { toHide[j++].map = null; n++; }

      if (i < toShow.length || j < toHide.length) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  }


  public async saveLocationChanges(x: LocationInfo) {
    await this.Api.post<any>("Settings/UpdateLocationTrailerPoint", null, { locationId: x.Id, radius: x.TrailerPointRadius, lat: x.TrailerPointLatitude, lng: x.TrailerPointLongitude });

    this.originalById.delete(x.Id);
    this.isChecked = false;
    this.isChanged = false;

    const marker = this.markersById.get(x.Id);
    if (marker) marker.gmpDraggable = false;
  }


  //Helper Function, Label - Content 
  private line = (label: string, value: string) => {
    if (value == null) return null;
    const div = document.createElement('div');
    const b = document.createElement('strong');
    b.textContent = `${label}: `;
    b.style.pointerEvents = 'none';
    div.append(b, document.createTextNode(value ?? ''));
    return div;
  };

  //Helper Function, with handel, Used with adress change.
  private lineWithHandle(label: string, value: string) {
    const div = document.createElement('div');
    const b = document.createElement('strong');
    b.textContent = `${label}: `;
    b.style.pointerEvents = 'none';

    const span = document.createElement('span');
    span.textContent = value;

    div.append(b, span);

    return {
      row: div,
      setValue: (v: string) => { span.textContent = v; }
    };
  }

  private installViewportHandler() {
    this.ngZone.runOutsideAngular(() => {
      let scheduled = false;
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          this.refreshViewportMarkers();
        });
      };
      //NOte: Dont use Zoom_changed, fires to often, causes perfomance issues.
      this.map.addListener('idle', schedule);
    });
  }

  // Holds/Updates a snap shot of the current changed LocationInfo.
  private updateSnapshot(id: number, loc: LocationInfo) {
    if (this.originalById.has(id)) return;

    const marker = this.markersById.get(id);
    const circle = this.circlesById.get(id);
    if (!marker || !circle) return;

    const pos = marker.position as google.maps.LatLng | google.maps.LatLngLiteral;
    const lat = pos instanceof google.maps.LatLng ? pos.lat() : pos.lat;
    const lng = pos instanceof google.maps.LatLng ? pos.lng() : pos.lng;

    this.originalById.set(id, {
      lat,
      lng,
      radius: circle.getRadius() ?? (loc.TrailerPointRadius ?? 0),
      draggable: !!marker.gmpDraggable,
    });
  }

  //Reverts the changes, set the Marker and Circle position, to the original state.
  private revertLocation(id: number) {
    const snapshot = this.originalById.get(id);

    if (!snapshot) return;

    const marker = this.markersById.get(id);
    const circle = this.circlesById.get(id);
    const location = (this.selectedLocation?.Id === id) ? this.selectedLocation : undefined;

    // Update marker position and lock it
    if (marker) {
      marker.gmpDraggable = false;
      marker.position = { lat: snapshot.lat, lng: snapshot.lng };
    }

    // Update circle center/radius and lock it
    if (circle) {
      circle.setCenter({ lat: snapshot.lat, lng: snapshot.lng });
      circle.setRadius(snapshot.radius);
      circle.setEditable(false);
    }

    // Update your bound model (so sliders/labels show the original again)
    if (location) {
      location.TrailerPointLatitude = snapshot.lat;
      location.TrailerPointLongitude = snapshot.lng;
      location.TrailerPointRadius = snapshot.radius;
    }

    //If the InfoWindow for this marker is open, refresh the “Current Address”
    if (marker) {
      const handle = this.addressHandleByMarker.get(marker);
      if (handle) {
        handle.setValue('Resolving…');
        this.reverseGeocode(snapshot.lat, snapshot.lng).then(addr =>
          handle.setValue(addr ?? 'Unavailable')
        );
      }
    }

    // Clear dirty state
    this.originalById.delete(id);
    this.isChecked = false;
    this.isChanged = false;

    this.refreshViewportMarkers?.();
  }

  private async ensureDiscardingUnsaved(nextId: number): Promise<boolean> {
    if (this.selectedLocation?.Id === nextId) return true;
    if (!this.isChanged) return true;

    const ok = await this.UI.confirm(
      'Turbo.CustomerService.Map.Confirm.msgTitle',
      'Discard unsaved changes?',
      'Turbo.CustomerService.Map.Confirm.msgDesc',
      'You’ve made changes that haven’t been saved yet. Your recent edits will be lost.'
    );

    if (!ok) return false;

    // user confirmed: revert and clear dirty state
    if (this.selectedLocation?.Id != null) {
      this.revertLocation(this.selectedLocation.Id);
    }
    this.isChanged = false;
    this.isChecked = false;
    return true;
  }


  private trailerMatchesConceptGroupLocation(trailer: RentalObjectWithLockInfo): boolean {
    const conceptId = this.conceptRentalLocationGroup || 0;
    const groupId = this.rentalLocationGroup || 0;
    const locId = this.locationId || 0;
    // Location filter.
    if (locId > 0) {
      
      if (trailer.LocationId !== locId) return false;
    }

    // Oneway Special Condition
    if (conceptId === 3) {
      return trailer.Concept === 'OneWay';
    }

    // Normal group logic
    if (conceptId === 0 && groupId === 0) {
      return true;
    }


    if (groupId > 0) {
      return trailer.GroupHierarchy
        ?.split('-')
        .includes(String(groupId)) ?? false;
    }

    if (conceptId > 0) {
      const concept = this.locationGroups.find(c => c.Id === conceptId);
      if (!concept) {
  
        return true; 
      }

      const childIds = new Set((concept.ChildGroups ?? []).map(g => g.Id));
      if (!trailer.GroupHierarchy) return false;

      return trailer.GroupHierarchy
        .split('-')
        .some(part => childIds.has(Number(part)));
    }

    // Fallback
    return true;
  }


  //Check if we can leave, incase we have pending changes that have not been saved.
  async canDeactivate(): Promise<boolean> {
    if (this.isChanged) {
      return await this.UI.confirm("Turbo.CustomerService.Map.ConfirmLeaving", "Unsaved changes", "Turbo.CustomerService.Map.msgConfirmLeaving", "You have unsaved changes. Are you sure you want to leave?");
    }
    return true;
  }

  //If we try and refresh the page, with pending changes.
  beforeUnloadListener = (event: BeforeUnloadEvent) => {
    if (this.isChanged) {
      event.preventDefault();
    }
  };


}

type ZoomMarker = google.maps.marker.AdvancedMarkerElement & {
  _id: number;
  minZoom?: number;
  maxZoom?: number;
  _iconImg?: HTMLImageElement;
  _iconWrapper?: HTMLDivElement;
};

type TrailerMarker = google.maps.marker.AdvancedMarkerElement & {
  _trailerId?: number;
  _locationId?: number;
  _iconImg?: HTMLImageElement;
  _openPopup?: () => Promise<boolean>;
};

type LocationSnapshot = {
  lat: number;
  lng: number;
  radius: number;
  draggable: boolean;
}
